import { writable } from 'svelte/store';
// Get theme from localStorage or default to dark
const getInitialTheme = () => {
    if (typeof window !== 'undefined') {
        const savedTheme = localStorage.getItem('koru_theme');
        if (savedTheme === 'light' || savedTheme === 'dark') {
            return savedTheme;
        }
    }
    return 'dark'; // Default to dark theme
};
// Create theme store
function createThemeStore() {
    const { subscribe, set, update } = writable(getInitialTheme());
    return {
        subscribe,
        setTheme: (theme) => {
            set(theme);
            if (typeof window !== 'undefined') {
                localStorage.setItem('koru_theme', theme);
                // Update document class for Tailwind dark mode
                if (theme === 'dark') {
                    document.documentElement.classList.add('dark');
                }
                else {
                    document.documentElement.classList.remove('dark');
                }
            }
        },
        toggle: () => {
            update((current) => {
                const newTheme = current === 'dark' ? 'light' : 'dark';
                if (typeof window !== 'undefined') {
                    localStorage.setItem('koru_theme', newTheme);
                    // Update document class for Tailwind dark mode
                    if (newTheme === 'dark') {
                        document.documentElement.classList.add('dark');
                    }
                    else {
                        document.documentElement.classList.remove('dark');
                    }
                }
                return newTheme;
            });
        },
        initialize: () => {
            const theme = getInitialTheme();
            set(theme);
            if (typeof window !== 'undefined') {
                if (theme === 'dark') {
                    document.documentElement.classList.add('dark');
                }
                else {
                    document.documentElement.classList.remove('dark');
                }
            }
        }
    };
}
export const themeStore = createThemeStore();
